// extracted by css-extract-rspack-plugin
export default {"cls1":"Search-cls1_iJP","cls2":"Search-cls2_f84 Search-cls1_iJP"};